import * as React from 'react'
import { SideDrawer } from '@sales-center/components'
import { AddServiceLocationDrawerProps } from './typings'
import { AddServiceLocationForm } from './AddServiceLocationForm'
import { EditMatchedLocationHeaderUpdate } from '../AllowEditMatchedLocation'
import { ServiceLocationTabs } from './ServiceLocationTabs'

export const AddServiceLocationDrawer: React.FC<
  AddServiceLocationDrawerProps
> = (props) => {
  const { open, onClose, initialValues, isBillingLocation, location, matched } =
    props

  const mode = !!initialValues ? 'Update' : 'Add'

  const type = isBillingLocation ? 'Bill-To' : 'Service'
  return (
    <SideDrawer
      title={`${mode} ${type} Location`}
      open={open}
      onClose={onClose}
      overflow="auto"
      width={550}
    >
      {location?.externalLinkId && (
        <EditMatchedLocationHeaderUpdate
          externalLocationId={location?.externalLinkId ?? ''}
          isBillTo={isBillingLocation}
        />
      )}

      {matched && mode === 'Add' ? (
        <ServiceLocationTabs {...props} />
      ) : (
        <AddServiceLocationForm
          {...props}
          matched={Boolean(location?.externalLinkId)}
          mode={mode}
          externalLocationId={location?.externalLinkId}
        />
      )}
    </SideDrawer>
  )
}
AddServiceLocationDrawer.displayName = 'AddServiceLocationDrawer'
